export default {
    zh: {
        potentialSupplierManage: '潜在供应商管理',
        SupplierManage: '供应商管理',
        supplierChinese: '供应商中文名称',
        supplierEnglish: '供应商英文名称',
        invitationDate: '邀请日期',
        supplierAbbreviation: '供应商简称',
        supplierInvitationCode: '供应商邀请码',
        InvitationCodeStatus: '邀请码状态',
        auditStatus: '审核状态',
        creater: '创建人',
        creationDate: '创建日期',
        SupplierType: 'SupplierType',
        domestic: '国内',
        abroad: '国外',
        DomesticOrforeign: '国内/国外',
        expiryDate: '邀请有效期',
        potentialSupplierInfoRegister: '潜在供应商信息登记',
        supplierBasicInfo: '供应商基础信息',
        confidentialityAgreement: '保密协议',
        supplierContacts: '供应商联系人',
        supplierType: '供应商类型',
        supplierInviter: '供应商邀请人',
        supplierAddressInfo: '供应商地址信息',
        supplierResourceManage: '供应商资源管理',
        suppliercode: '供应商编码',
        factoryName: '工厂名称',
        supplierStatus: '供应商状态',
        NewSSsupplier: '新建SS供应商',
        NewNoSSsupplier: '新建非SS/NFC供应商',
        NewNFC: '新建NFC供应商',
        supplierCategoryInfo: '供应商品类信息',
        SSDataUpdate: 'SS数据更新',
        approvalSuppliers: '批准供应商',
        SuppliersApproval: '供应商批准',
        changeOfficialSupplier: '是否将供应商的转为正式供应商？',
        isUpdateData: '是否更新供应商信息数据',
        approvalWindow: '审批操作窗口',
        socialUniformCreditCode: '社会统一信用代码',
        area: '区域',
        fileName: '文件名',
        PleaseAddSupplier: '请添加供应商',
        Category1: '品类1',
        Category2: '品类2',
        IncorrectFormat: '格式不正确',
        agreementNotAudit: '保密协议暂未通过审核',
        leastTwoAddress: '至少两行地址明细',
        selectArea: '请选择区域',
        dataUpdate: '数据更新',
        supplierAudit: '供应商批准',
        leastAgreement: '每个工厂至少上传一个资质文件，请检查',
        agreementDownload: '保密协议下载',
        apply: '申请',
        position: '职位',
        basicInfo: '基础信息',
        Unapprove: '未批准',
        Approve: '批准',
        audit: '审批',
        SubmitBy: '选择审批人',




    },
    en: {
        SupplierManage: 'SupplierManage',
        potentialSupplierManage: 'Potential supplier management',
        supplierChinese: 'Chinese name of supplier',
        supplierEnglish: 'English name of supplier',
        invitationDate: 'Invitation date',
        supplierAbbreviation: 'Supplier abbreviation',
        supplierInvitationCode: 'Supplier invitation code',
        InvitationCodeStatus: 'Invitation code status',
        auditStatus: 'Audit status',
        creater: 'creater',
        creationDate: 'creationDate',
        SupplierType: 'SupplierType',
        domestic: 'domestic',
        abroad: 'abroad',
        DomesticOrforeign: 'Domestic / foreign',
        expiryDate: 'term of validity',
        supplierBasicInfo: 'Basic information of suppliers',
        confidentialityAgreement: 'Confidentiality agreement',
        supplierContacts: 'Supplier Contact',
        supplierType: 'Supplier Type',
        supplierInviter: 'Supplier Inviter',
        supplierAddressInfo: 'Supplier address information',
        supplierResourceManage: 'Supplier resource management',
        suppliercode: 'Supplier code',
        factoryName: 'Name of factory',
        supplierStatus: 'Supplier status',
        NewSSsupplier: 'New SS supplier',
        NewNoSSsupplier: 'New non SS/NFC supplier',
        NewNFC: 'New NFC',
        supplierCategoryInfo: 'Supplier Category Info',
        SSDataUpdate: 'SS data update',
        approvalSuppliers: 'Approval of suppliers',
        changeOfficialSupplier: "Is the supplier's official supplier changed?",
        isUpdateData: 'Update supplier data',
        SuppliersApproval: 'SuppliersApproval',
        approvalWindow: 'Approval window',
        socialUniformCreditCode: 'socialUniformCreditCode',
        area: 'area',
        fileName: 'fileName',
        PleaseAddSupplier: 'Please add supplier',
        Category1: 'Category1',
        Category2: 'Category2',
    }
}